import React, {
  useEffect,
  useMemo,
  useState,
  useRef,
  useCallback,
} from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { fetchMarkersLandingPage } from "../services/api"; // Assuming this is available
import Header from "./Header";
import HOC from "./HOC"; // Assuming HOC is still needed
import "./style.css";
import "./responsive.css";
import Footer from "../components/Footer";
import bubble1 from "../assets/bubbles/bubble1.png";
import bubble2 from "../assets/bubbles/bubble2.png";
import bubble3 from "../assets/bubbles/bubble3.png";
import bubble4 from "../assets/bubbles/bubble4.png";
import bubble5 from "../assets/bubbles/bubble5.png";
import bubble6 from "../assets/bubbles/bubble6.png";
import SerendipityNetworkGraph from "./SerendipityNetworkGraph";
import img2 from "../Assets/Home Screen.png";
import img3 from "../Assets/Profile.png";
import img4 from "../Assets/Report.png";
import img from "../Assets/Add goal.png";
import goalDetails from "../Assets/Goal Details  2.png";
import playstore from "../Assets/PlayStore Button.png";
import appStore from "../Assets/AppStore Button.png";
import sidImage from "../Assets/planets-big-1.webp";
import Users from "../Assets/users.webp";
import GLOBE from "../Assets/planets-big-2.webp";
import users from "../Assets/author-2.webp";
import APPIMG from "../Assets/app-store.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import countryList from "react-select-country-list";

const cityCenters = {
  Breda: { lat: 51.5719, lng: 4.7683 },
  Amsterdam: { lat: 52.3676, lng: 4.9041 },
};

const mapStyles = [
  { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
  {
    featureType: "transit",
    elementType: "all",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "administrative",
    elementType: "labels",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "road",
    elementType: "labels",
    stylers: [{ visibility: "on" }],
  },
];

function cx(...classes) {
  return classes.filter(Boolean).join(" ");
}

const GOOGLE_MAPS_API_KEY =
  "AIzaSyBdwa9nNF-lhPPGNRPzCiXcngQNkSVw34M";

function EcosystemPillarCard({ label, accent, icon }) {
  return (
    <div
      className={cx(
        "relative flex min-h-[4.5rem] items-center gap-4 rounded-2xl px-4 py-3.5 backdrop-blur-md transition-transform duration-300 sm:min-h-[5rem] sm:px-5 sm:py-4",
        "bg-white/75 shadow-[0_16px_46px_rgba(2,132,199,0.08)] ring-1 ring-white/85",
        "hover:-translate-y-0.5",
        accent &&
          "shadow-[0_22px_52px_rgba(34,211,238,0.22)] ring-cyan-100/90",
      )}
    >
      {accent && (
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-14 rounded-b-2xl bg-gradient-to-t from-cyan-200/45 via-cyan-100/12 to-transparent" />
      )}
      <div className="relative flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-cyan-50 ring-1 ring-cyan-100/90 sm:h-14 sm:w-14">
        {icon}
      </div>
      <div className="relative text-left text-sm font-bold text-slate-900 sm:text-base">
        {label}
      </div>
    </div>
  );
}

function Landing(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth > 425);
  const navigate = useNavigate();
  const location = useLocation();
  const aboutUsRef = useRef(null);
  const feedbackRef = useRef(null);
  const homeRef = useRef(null);
  const featuresRef = useRef(null);
  const serendipityRef = useRef(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const [filter, setFilter] = useState("");
  const options = countryList().getData();
  const [city] = useState("Breda");
  const [markers, setMarkers] = useState([]);
  const [error, setError] = useState(null);

  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-maps-script-serendipity-landing",
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    version: "weekly",
  });
  const [retryCount, setRetryCount] = useState(0);
  const maxRetries = 3;

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const scrollToAboutUs = () => {
    if (aboutUsRef.current) {
      aboutUsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const scrollToFeatures = useCallback(() => {
    featuresRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  const forceSmoothScrollTo = useCallback((targetRef) => {
    const target = targetRef.current;
    if (!target) return;

    const headerHeight =
      document.querySelector("header")?.getBoundingClientRect().height || 0;
    const targetTop = Math.max(
      target.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight -
        8,
      0,
    );
    const prefersReducedMotion = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)",
    )?.matches;
    const behavior = prefersReducedMotion ? "auto" : "smooth";
    const scrollToTarget = () => {
      window.scrollTo({ top: targetTop, behavior });
    };

    if (Math.abs(window.pageYOffset - targetTop) < 12) {
      window.scrollTo({
        top: Math.max(targetTop - 80, 0),
        behavior: "auto",
      });
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(scrollToTarget);
      });
      return;
    }

    scrollToTarget();
  }, []);

  const scrollToSerendipitySection = useCallback(() => {
    forceSmoothScrollTo(serendipityRef);
  }, [forceSmoothScrollTo]);

  const scrollToFeedback = () => {
    if (feedbackRef.current) {
      feedbackRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToHome = () => {
    if (homeRef.current) {
      homeRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const loadMarkers = useCallback(async () => {
    try {
      const data = await fetchMarkersLandingPage();
      setMarkers(Array.isArray(data) ? data : data.Response || []);
      setError(null);
      setRetryCount(0);
    } catch (error) {
      console.error("Error fetching markers:", error);
      if (retryCount < maxRetries) {
        const delay = Math.pow(2, retryCount) * 1000;
        setTimeout(() => {
          setRetryCount(retryCount + 1);
          loadMarkers();
        }, delay);
      } else {
        setError(
          "Failed to load markers after multiple attempts. Please try again.",
        );
      }
    }
  }, [retryCount]);

  useEffect(() => {
    const hash = (location.hash || "").replace(/^#/, "");
    if (!hash) return undefined;
    const map = {
      features: featuresRef,
      serendipity: serendipityRef,
      contact: feedbackRef,
    };
    const target = map[hash];
    if (!target) return undefined;
    const id = window.setTimeout(() => {
      if (hash === "serendipity") {
        forceSmoothScrollTo(target);
        return;
      }
      target.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
    return () => window.clearTimeout(id);
  }, [forceSmoothScrollTo, location.pathname, location.hash]);

  useEffect(() => {
    window.addEventListener(
      "resize",
      () => {
        const ismobile = window.innerWidth > 425;
        if (ismobile !== isMobile) setIsMobile(ismobile);
      },
      false,
    );
    return () => window.removeEventListener("resize", () => {});
  }, [isMobile]);

  useEffect(() => {
    if (isLoaded) {
      loadMarkers();
    }
  }, [isLoaded, loadMarkers]);

  const handleRetry = () => {
    setError(null);
    setRetryCount(0);
    if (loadError) {
      window.location.reload();
      return;
    }
    loadMarkers();
  };

  const mapSectionError =
    (loadError instanceof Error
      ? loadError.message
      : typeof loadError === "string"
        ? loadError
        : "") || error;

  const videoId = "9JZTcoq0Pzo";

  const stats = useMemo(
    () => [
      { value: "10K+", label: "Active Users" },
      { value: "50K+", label: "Goals Tracked" },
      { value: "98%", label: "Satisfaction" },
      { value: "∞", label: "Discoveries" },
    ],
    [],
  );

  // Palette matched to reference (soft light-blue/teal)
  const palette = useMemo(
    () => ({
      pageFrom: "#ECFCFF",
      pageVia: "#F6FEFF",
      pageTo: "#FFFFFF",
      // slightly more vibrant band like reference behind "Serendipity Engine"
      bandFrom: "#BFEFFF",
      bandVia: "#D6F8FF",
      bandTo: "#F2FDFF",
      footerBg: "#F6FBFD",
      bubble1: "rgba(0, 198, 255, 0.18)",
      bubble2: "rgba(0, 114, 255, 0.10)",
      bubble3: "rgba(34, 211, 238, 0.10)",
    }),
    [],
  );

  const softCard =
    "rounded-3xl border border-white/90 bg-white/90 shadow-[0_22px_60px_rgba(2,132,199,0.12)] backdrop-blur-sm";
  const softCardInteractive =
    "transition-transform duration-300 hover:-translate-y-1 hover:shadow-[0_28px_80px_rgba(2,132,199,0.16)]";

  const primaryGradient = useMemo(
    () => ({
      backgroundImage:
        "linear-gradient(90deg, #00C6FF 0%, #009BFF 40%, #0072FF 100%)",
    }),
    [],
  );

  useEffect(() => {
    const els = Array.from(document.querySelectorAll(".bsi-reveal"));
    if (!els.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.12, rootMargin: "0px 0px -10% 0px" },
    );

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <>
      <Header
        scrollToAboutUs={scrollToAboutUs}
        scrollToFeatures={scrollToFeatures}
        scrollToSerendipity={scrollToSerendipitySection}
        fixed
        scrollToHome={scrollToHome}
        scrollToFeedback={scrollToFeedback}
        aboutUsRef={aboutUsRef}
        feedbackRef={feedbackRef}
      />

      <div className="min-h-screen flex flex-col">
        <main
          className="relative isolate flex-grow bg-gradient-to-b"
          style={{
            background:
              "linear-gradient(135deg,rgb(248, 248, 234) 0%, #cfeaf5 40%, #a8d7e8 70%, #7fc8e3 100%)",
          }}
        >
          {/* Center radial glow burst (critical) */}
          {/* <div className="absolute inset-0 z-0 pointer-events-none">
          <div
            style={{
              position: "absolute",
              top: "40%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "900px",
              height: "900px",
              // background:
                // "radial-gradient(circle, rgba(0, 200, 255, 0.25) 0%, rgba(0, 200, 255, 0.12) 30%, transparent 70%)",
              // filter: "blur(80px)",s
            }}
          />
        </div> */}

          {/* Figma bubble background (PNG assets only) */}
          <div className="bsi-bubble-layer pointer-events-none absolute inset-0 z-[1] overflow-hidden">
            {/* Top Left: small bubble */}
            <img
              src={bubble5}
              alt=""
              className="bsi-bubble-img bsi-float"
              style={{
                // width: "screen",
                opacity: 2,
                // filter: "blur(6px) drop-shadow(0 0 80px rgba(0,200,255,0.5))",
                // animationDelay: "-1.5s",
              }}
            />

            {/* Top Right: large bubble */}
            <img
              src={bubble6}
              alt=""
              className="bsi-bubble-img bsi-float bsi-bubble-hide-mobile"
              // style={{
              //   top: "10%",
              //   right: "-10%",
              //   width: 650,
              //   opacity: 0.85,
              //   filter: "blur(6px) drop-shadow(0 0 80px rgba(0,200,255,0.5))",
              //   animationDelay: "-3.2s",
              // }}
            />

            {/* Mid Right: glow rectangle bubble */}
            <img
              src={bubble4}
              alt=""
              className="bsi-bubble-img bsi-float bsi-bubble-hide-mobile"
              style={{
                bottom: "5%",
                // left: "50%",
                width: "100%",
                opacity: 10,
                // filter: "blur(10px) drop-shadow(0 0 80px rgba(0,200,255,0.5))",
                transform: "translateX(-50%)",
                zIndex: 1000,
                animationDelay: "-2.2s",
              }}
            />

            {/* Center Accent: big glowing bubble behind content */}
            <div
              className="bsi-bubble-center bsi-bubble-hide-mobile"
              style={{
                top: "40%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <img
                src={bubble5}
                alt=""
                className="bsi-bubble-img bsi-float"
                style={{
                  width: 680,
                  opacity: 0.85,
                  filter:
                    "blur(10px) drop-shadow(0 0 80px rgba(0,200,255,0.5))",
                  animationDelay: "-2.4s",
                }}
              />
            </div>

            {/* Bottom Left: large soft bubble */}
            <img
              src={bubble6}
              alt=""
              className="bsi-bubble-img bsi-float"
              style={{
                bottom: "-5%",
                left: "-5%",
                width: 650,
                opacity: 0.85,
                filter: "blur(10px) drop-shadow(0 0 80px rgba(0,200,255,0.5))",
                animationDelay: "-6.8s",
              }}
            />

            {/* Bottom Right: medium bubble */}
            <img
              src={bubble1}
              alt=""
              className="bsi-bubble-img bsi-float"
              style={{
                bottom: "10%",
                right: "5%",
                width: 320,
                opacity: 0.85,
                filter: "blur(6px) drop-shadow(0 0 80px rgba(0,200,255,0.5))",
                animationDelay: "-4.4s",
              }}
            />

            {/* Extra bubbles for density (8–12 total) */}
            <img
              src={bubble1}
              alt=""
              className="bsi-bubble-img bsi-float"
              style={{
                top: "22%",
                left: "-6%",
                width: 560,
                opacity: 0.85,
                filter: "blur(10px) drop-shadow(0 0 80px rgba(0,200,255,0.5))",
                animationDelay: "-7.2s",
              }}
            />
          
            <img
              src={bubble3}
              alt=""
              className="bsi-bubble-img bsi-float"
              style={{
                top: "66%",
                right: "2%",
                width: 260,
                opacity: 0.85,
                filter: "blur(6px) drop-shadow(0 0 80px rgba(0,200,255,0.5))",
                animationDelay: "-5.6s",
              }}
            />
            <img
              src={bubble2}
              alt=""
              className="bsi-bubble-img bsi-float bsi-bubble-hide-mobile"
              style={{
                bottom: "32%",
                // left: "50%",
                width: "100%",
                opacity: 2,
                // filter: "blur(10px) drop-shadow(0 0 80px rgba(0,200,255,0.5))",
                transform: "translateX(-50%)",
                animationDelay: "-2.2s",
              }}
            />
          </div>

          {/* Removed CSS-circle bubble overlays (image bubbles only) */}

          <div className="relative z-10">
            {/* Hero */}
            <section ref={homeRef} className="bsi-reveal pt-32 sm:pt-36">
              <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
                <div className="text-center">
                  <h1 className="mx-auto max-w-3xl text-balance text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl sm:leading-[1.1]">
                  Goal Tracking Software{" "}
                    <span className="text-cyan-500">Built</span> for Clarity,
                    <br className="hidden sm:block" /> Not Pressure.
                  </h1>
                  <p className="mx-auto mt-5 max-w-2xl text-pretty text-sm font-medium leading-6 text-slate-500 sm:text-base">
                  A modern goal tracking software designed to help you set goals, track progress, 
                  and discover patterns—so you can grow consistently without burnout.
                  More than a typical goal setting software, this system helps you understand what actually works for you.
                  </p>

                  <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
                    <button
                      onClick={() => navigate("/signup")}
                      className="w-full rounded-full px-7 py-3.5 text-sm font-semibold text-white shadow-[0_18px_34px_rgba(0,114,255,0.26)] hover:brightness-95 sm:w-auto"
                      style={primaryGradient}
                    >
                      Get Started Today
                    </button>
                    <button
                      onClick={scrollToAboutUs}
                      className="w-full rounded-full border border-white/70 bg-white/80 px-7 py-3.5 text-sm font-semibold text-slate-700 shadow-[0_10px_22px_rgba(15,23,42,0.06)] hover:bg-white sm:w-auto"
                    >
                      Learn more
                    </button>
                  </div>

                  <div
                    className="invisible mt-10 grid grid-cols-2 gap-6 sm:grid-cols-4 sm:gap-10"
                    aria-hidden="true"
                  >
                    {stats.map((s) => (
                      <div key={s.label} className="text-center">
                        <div className="text-2xl font-extrabold tracking-tight text-cyan-500 sm:text-3xl">
                          {s.value}
                        </div>
                        <div className="mt-1 text-xs font-semibold text-slate-500 sm:text-sm">
                          {s.label}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>

            {/* Serendipity Engine */}
            <section
              id="serendipity"
              ref={(node) => {
                serendipityRef.current = node;
                aboutUsRef.current = node;
              }}
              className="bsi-reveal scroll-mt-20 relative w-full overflow-hidden pt-10 sm:scroll-mt-24 sm:pt-12"
            >
              <div className="pointer-events-none absolute inset-0 -z-10">
                <div className="absolute left-1/2 top-10 h-[520px] w-[920px] -translate-x-1/2 rounded-full bg-cyan-200/25 blur-3xl" />
                <div className="absolute left-1/2 top-32 h-[520px] w-[980px] -translate-x-1/2 rounded-full bg-sky-200/18 blur-3xl" />
              </div>
              {/* subtle particles */}
              <div className="pointer-events-none absolute inset-0">
                {[
                  { s: 3, l: "12%", t: "18%", o: 0.16, d: 24, dl: -4 },
                  { s: 2, l: "22%", t: "44%", o: 0.12, d: 28, dl: -10 },
                  { s: 3, l: "34%", t: "30%", o: 0.1, d: 30, dl: -14 },
                  { s: 2, l: "48%", t: "20%", o: 0.1, d: 26, dl: -8 },
                  { s: 3, l: "62%", t: "36%", o: 0.12, d: 32, dl: -18 },
                  { s: 2, l: "74%", t: "22%", o: 0.12, d: 27, dl: -6 },
                  { s: 3, l: "86%", t: "40%", o: 0.1, d: 34, dl: -22 },
                  { s: 2, l: "18%", t: "70%", o: 0.1, d: 36, dl: -26 },
                  { s: 3, l: "52%", t: "78%", o: 0.1, d: 38, dl: -30 },
                  { s: 2, l: "82%", t: "72%", o: 0.1, d: 40, dl: -34 },
                ].map((p, i) => (
                  <span
                    key={i}
                    className="bsi-cta-dot"
                    style={{
                      width: `${p.s}px`,
                      height: `${p.s}px`,
                      left: p.l,
                      top: p.t,
                      opacity: p.o,
                      animationDuration: `${p.d}s`,
                      animationDelay: `${p.dl}s`,
                    }}
                  />
                ))}
              </div>

              <div className="w-full pt-6 sm:pt-10">
                {/* VIDEO - top of the Serendipity section */}
                <section className="w-full py-10 sm:py-12">
                  <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
                    <div className="mx-auto w-full max-w-6xl">
                      <div className="relative w-full overflow-hidden rounded-2xl bg-slate-100">
                        <div className="aspect-video w-full">
                          <iframe
                            title="Serendipity video"
                            className="h-full w-full"
                            src={`https://www.youtube.com/embed/${videoId}`}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <div className="mx-auto mt-6 max-w-7xl px-4 pb-16 sm:mt-10 sm:pb-20 sm:px-6 lg:px-10">
                  <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-12">
                    <div className="text-left">
                      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
                        The Core Engine
                      </p>
                      <h2 className="mt-3 text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
                        The <span className="text-cyan-500">Serendipity</span>{" "}
                        Engine
                      </h2>
                      <p className="mt-4 max-w-xl text-sm font-medium leading-relaxed text-slate-600 sm:text-base">
                        A system that connects your actions and reveals insights
                        you didn&apos;t know to look for.
                      </p>
                      <ul className="mt-6 space-y-3 text-sm font-medium text-slate-700 sm:text-[15px]">
                        {[
                          "See how different goals influence each other",
                          "Discover unexpected patterns in your behavior",
                          "Understand your real growth triggers",
                        ].map((item) => (
                          <li key={item} className="flex gap-3">
                            <span
                              className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-cyan-500"
                              aria-hidden
                            />
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                      <p className="mt-8 text-base font-bold text-cyan-600 sm:text-lg">
                        This isn&apos;t random. It&apos;s pattern intelligence
                        built around you.
                      </p>
                    </div>

                    <div className="relative mx-auto w-full max-w-xl lg:max-w-none">
                      <div className="overflow-hidden rounded-2xl shadow-[0_24px_60px_rgba(2,132,199,0.15)] ring-1 ring-slate-200/70">
                        <SerendipityNetworkGraph />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Features */}
            <section
              id="features"
              ref={featuresRef}
              className="bsi-reveal scroll-mt-20 relative w-full overflow-hidden py-20 sm:scroll-mt-24 sm:py-28"
            >
              <div className="pointer-events-none absolute inset-0 -z-10">
                <div className="absolute left-1/2 top-16 h-[520px] w-[980px] -translate-x-1/2 rounded-full bg-cyan-200/18 blur-3xl" />
                <div className="absolute left-1/2 top-56 h-[560px] w-[980px] -translate-x-1/2 rounded-full bg-sky-200/14 blur-3xl" />
              </div>
              {/* subtle particles */}
              <div className="pointer-events-none absolute inset-0">
                {[
                  { s: 3, l: "10%", t: "18%", o: 0.12, d: 26, dl: -8 },
                  { s: 2, l: "22%", t: "62%", o: 0.1, d: 30, dl: -16 },
                  { s: 3, l: "38%", t: "26%", o: 0.1, d: 28, dl: -12 },
                  { s: 2, l: "54%", t: "72%", o: 0.1, d: 34, dl: -20 },
                  { s: 3, l: "70%", t: "20%", o: 0.1, d: 32, dl: -18 },
                  { s: 2, l: "86%", t: "58%", o: 0.1, d: 36, dl: -24 },
                ].map((p, i) => (
                  <span
                    key={i}
                    className="bsi-cta-dot"
                    style={{
                      width: `${p.s}px`,
                      height: `${p.s}px`,
                      left: p.l,
                      top: p.t,
                      opacity: p.o,
                      animationDuration: `${p.d}s`,
                      animationDelay: `${p.dl}s`,
                    }}
                  />
                ))}
              </div>

              <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
                <div className="relative text-center">
                  <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
                    Features
                  </p>
                  <h3 className="mx-auto mt-3 max-w-4xl text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
                    Everything You Need to{" "}
                    <span className="text-cyan-600">Grow</span>
                    <span className="text-slate-900">—Without Burnout.</span>
                  </h3>
                </div>

                <div className="relative mx-auto mt-12 grid max-w-7xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-7">
                  {[
                    {
                      title: "Goal Tracking System",
                      desc: "Stay consistent with a flexible, low-pressure structure.",
                      card:
                        "bg-teal-50/90 ring-teal-100/50 shadow-[0_16px_46px_rgba(2,132,199,0.08)]",
                      iconWrap: "bg-white/75 ring-teal-200/40",
                      icon: (
                        <svg
                          viewBox="0 0 24 24"
                          className="h-9 w-9"
                          fill="none"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          aria-hidden
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="9"
                            className="stroke-rose-500"
                          />
                          <circle
                            cx="12"
                            cy="12"
                            r="5"
                            className="stroke-rose-500"
                          />
                          <circle cx="12" cy="12" r="1.5" className="fill-sky-500 stroke-none" />
                          <path
                            d="M12 3v3M12 18v3M3 12h3M18 12h3"
                            className="stroke-slate-400"
                            strokeWidth="1.5"
                          />
                        </svg>
                      ),
                    },
                    {
                      title: "Pattern Discovery",
                      desc: "See how your habits and actions connect over time.",
                      card:
                        "bg-violet-50/90 ring-violet-100/50 shadow-[0_16px_46px_rgba(2,132,199,0.08)]",
                      iconWrap: "bg-white/75 ring-violet-200/40",
                      icon: (
                        <svg
                          viewBox="0 0 24 24"
                          className="h-9 w-9 text-slate-600"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          aria-hidden
                        >
                          <circle cx="11" cy="11" r="7" />
                          <path d="m20 20-4.3-4.3" />
                        </svg>
                      ),
                    },
                    {
                      title: "Clear Insights",
                      desc: "Get simple, actionable trends—no overwhelm.",
                      card:
                        "bg-amber-50/85 ring-amber-100/50 shadow-[0_16px_46px_rgba(2,132,199,0.08)]",
                      iconWrap: "bg-white/75 ring-amber-200/40",
                      icon: (
                        <svg
                          viewBox="0 0 24 24"
                          className="h-9 w-9"
                          fill="none"
                          aria-hidden
                        >
                          <path
                            d="M4 18h16"
                            className="stroke-slate-300"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                          <path
                            d="M6 14l3-4 3 2 4-6 3 3"
                            className="stroke-rose-500"
                            strokeWidth="2.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M18 8l2-1 1 3"
                            className="stroke-sky-500"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      ),
                    },
                    {
                      title: "Gentle Feedback",
                      desc: "Supportive guidance without judgment.",
                      card:
                        "bg-slate-50/95 ring-slate-200/60 shadow-[0_16px_46px_rgba(2,132,199,0.08)]",
                      iconWrap: "bg-white/80 ring-slate-200/50",
                      icon: (
                        <svg
                          viewBox="0 0 24 24"
                          className="h-9 w-9"
                          fill="currentColor"
                          aria-hidden
                        >
                          <path
                            className="text-emerald-600"
                            d="M12 22s-4-3.5-4-9c0-3 2-6 4-8 2 2 4 5 4 8 0 5.5-4 9-4 9z"
                          />
                          <path
                            className="text-emerald-500"
                            d="M12 6c0-3 2.5-5 5-5-1 3-3 5-5 5z"
                          />
                        </svg>
                      ),
                    },
                  ].map((f) => (
                    <div
                      key={f.title}
                      className={cx(
                        "rounded-2xl p-6 backdrop-blur-sm transition-transform duration-300",
                        "hover:-translate-y-1 hover:shadow-[0_22px_66px_rgba(2,132,199,0.12)]",
                        "ring-1",
                        f.card,
                      )}
                    >
                      <div
                        className={cx(
                          "mb-4 flex h-14 w-14 items-center justify-center rounded-2xl shadow-inner ring-1",
                          f.iconWrap,
                        )}
                      >
                        {f.icon}
                      </div>
                      <div className="text-left text-base font-extrabold tracking-tight text-slate-900">
                        {f.title}
                      </div>
                      <p className="mt-2 text-left text-sm font-normal leading-relaxed text-slate-700">
                        {f.desc}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* How it works — goal planning steps */}
            <section
              id="how-it-works"
              className="bsi-reveal relative w-full overflow-hidden py-16 sm:py-24"
            >
              <div className="pointer-events-none absolute inset-0 -z-10">
                <div className="absolute left-1/2 top-8 h-[480px] w-[900px] -translate-x-1/2 rounded-full bg-cyan-200/14 blur-3xl" />
                <div className="absolute left-1/2 top-40 h-[420px] w-[820px] -translate-x-1/2 rounded-full bg-sky-200/12 blur-3xl" />
              </div>
              <div className="pointer-events-none absolute inset-0">
                {[
                  { s: 2, l: "14%", t: "22%", o: 0.1, d: 28, dl: -6 },
                  { s: 3, l: "82%", t: "38%", o: 0.08, d: 32, dl: -12 },
                ].map((p, i) => (
                  <span
                    key={i}
                    className="bsi-cta-dot"
                    style={{
                      width: `${p.s}px`,
                      height: `${p.s}px`,
                      left: p.l,
                      top: p.t,
                      opacity: p.o,
                      animationDuration: `${p.d}s`,
                      animationDelay: `${p.dl}s`,
                    }}
                  />
                ))}
              </div>

              <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
                <h3 className="text-center text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
                  Simple Goal Planning Software{" "}
                  <span className="text-cyan-600">That Adapts to You.</span>
                </h3>

                <div className="mx-auto mt-10 flex max-w-6xl flex-col items-stretch gap-4 sm:mt-12 lg:mt-14 lg:flex-row lg:items-center lg:gap-3">
                  {[
                    {
                      num: "01",
                      title: "Set Your Goals",
                      desc: "Define what truly matters using a flexible system",
                      accent: true,
                    },
                    {
                      num: "02",
                      title: "Track Your Actions",
                      desc: "Log progress naturally without pressure or rigidity",
                      accent: false,
                    },
                    {
                      num: "03",
                      title: "Discover Patterns",
                      desc: "See insights that help you improve over time",
                      accent: false,
                    },
                  ].map((step, idx) => (
                    <React.Fragment key={step.num}>
                      <div
                        className={cx(
                          "relative flex min-h-[160px] flex-1 flex-col rounded-2xl p-6 shadow-[0_16px_46px_rgba(2,132,199,0.08)] ring-1 backdrop-blur-md transition-transform duration-300 lg:min-h-[180px]",
                          "bg-white/75 ring-white/80 hover:-translate-y-0.5",
                          step.accent &&
                            "shadow-[0_20px_50px_rgba(34,211,238,0.18)] ring-cyan-100/80",
                        )}
                      >
                        {step.accent && (
                          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 rounded-b-2xl bg-gradient-to-t from-cyan-200/35 via-cyan-100/15 to-transparent" />
                        )}
                        <div className="relative">
                          <span className="inline-flex h-9 min-w-[2.75rem] items-center justify-center rounded-lg bg-cyan-100 text-sm font-bold tabular-nums text-cyan-700 ring-1 ring-cyan-200/60">
                            {step.num}
                          </span>
                          <div className="mt-4 text-lg font-extrabold tracking-tight text-slate-900">
                            {step.title}
                          </div>
                          <p className="mt-2 text-sm font-medium leading-relaxed text-slate-600">
                            {step.desc}
                          </p>
                        </div>
                      </div>

                      {idx < 2 && (
                        <div
                          className="flex shrink-0 justify-center py-1 text-slate-300 lg:py-0 lg:px-1"
                          aria-hidden
                        >
                          <svg
                            className="h-8 w-8 rotate-90 lg:rotate-0"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="m9 18 6-6-6-6" />
                          </svg>
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </section>

            {/* Growth ecosystem */}
            <section
              id="growth-ecosystem"
              className="bsi-reveal relative w-full overflow-hidden pb-14 pt-14 sm:pb-20 sm:pt-20"
            >
              <div className="pointer-events-none absolute inset-0 -z-10">
                <div className="absolute left-1/2 top-14 h-[420px] w-[860px] -translate-x-1/2 rounded-full bg-cyan-200/16 blur-3xl" />
                <div className="absolute left-1/2 top-40 h-[380px] w-[720px] -translate-x-1/2 rounded-full bg-sky-200/12 blur-3xl" />
              </div>
              <div className="pointer-events-none absolute inset-0">
                {[
                  { s: 3, l: "10%", t: "40%", o: 0.1, d: 30, dl: -8 },
                  { s: 2, l: "88%", t: "55%", o: 0.1, d: 34, dl: -14 },
                  { s: 3, l: "48%", t: "72%", o: 0.08, d: 36, dl: -20 },
                ].map((p, i) => (
                  <span
                    key={i}
                    className="bsi-cta-dot"
                    style={{
                      width: `${p.s}px`,
                      height: `${p.s}px`,
                      left: p.l,
                      top: p.t,
                      opacity: p.o,
                      animationDuration: `${p.d}s`,
                      animationDelay: `${p.dl}s`,
                    }}
                  />
                ))}
              </div>

              <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
                <div className="pointer-events-none absolute left-1/2 top-1/2 h-44 w-[min(92vw,560px)] -translate-x-1/2 -translate-y-1/2 rounded-full bg-cyan-200/20 blur-3xl" />

                <div className="relative mx-auto max-w-5xl text-center">
                  <h3 className="text-[28px] font-bold uppercase leading-[1.2] tracking-[-0.02em] text-[#0F172A] sm:text-[32px] lg:text-[36px]">
                    YOUR GROWTH ECOSYSTEM
                  </h3>
                  <p className="mx-auto mt-2 max-w-xl text-sm font-normal leading-relaxed text-[#64748B] sm:mt-3 sm:text-base">
                    Your growth isn&apos;t linear—and neither is our system.
                  </p>
                </div>

                <div className="relative mx-auto mt-10 max-w-5xl space-y-4 sm:mt-12 md:space-y-5">
                  <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
                    {[
                      {
                        id: "time",
                        label: "Time Management",
                        accent: false,
                        icon: (
                          <svg
                            viewBox="0 0 24 24"
                            className="h-7 w-7 text-slate-600"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.75"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden
                          >
                            <path d="M5 22h14M5 2h14M8 2v4.5l4 3.5 4-3.5V2M8 22v-4.5l4-3.5 4 3.5v4.5" />
                            <path
                              d="M12 10v4"
                              className="text-cyan-600"
                            />
                          </svg>
                        ),
                      },
                      {
                        id: "health",
                        label: "Health & Wellness",
                        accent: false,
                        icon: (
                          <svg
                            viewBox="0 0 24 24"
                            className="h-7 w-7 text-slate-600"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.75"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden
                          >
                            <path
                              d="M19 14c1.5-1.5 3-3.2 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.8 0-3 .5-4.5 2-1.5-1.5-2.7-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4 3 5.5l7 7Z"
                              fill="currentColor"
                              className="text-rose-400"
                              stroke="none"
                            />
                            <path d="M4 15h3l2-2 2 3.5 2-3h7" />
                            <path
                              d="M5 20c1.2-2 2.2-3 3.5-3h1l1.2 2.2"
                              className="text-emerald-600"
                            />
                          </svg>
                        ),
                      },
                      {
                        id: "productivity",
                        label: "Productivity",
                        accent: false,
                        icon: (
                          <svg
                            viewBox="0 0 24 24"
                            className="h-7 w-7 text-slate-600"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.75"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden
                          >
                            <path d="M12 19V5M12 5l-4 4M12 5l4 4" />
                            <path
                              d="M8 3.5h1l.5 1M15 3.5h1l-.5 1"
                              className="text-cyan-600"
                            />
                            <circle
                              cx="17"
                              cy="8"
                              r="1.1"
                              className="fill-cyan-500"
                            />
                            <circle
                              cx="19.5"
                              cy="11.5"
                              r="0.9"
                              className="fill-cyan-400/90"
                            />
                            <circle
                              cx="6.5"
                              cy="9"
                              r="0.9"
                              className="fill-cyan-400/90"
                            />
                          </svg>
                        ),
                      },
                    ].map((c) => (
                      <EcosystemPillarCard key={c.id} {...c} />
                    ))}
                  </div>

                  <div className="grid grid-cols-1 gap-4 sm:mx-auto sm:max-w-2xl sm:grid-cols-2 sm:gap-5 md:max-w-none md:grid-cols-6">
                    {[
                      {
                        id: "creativity",
                        label: "Creativity",
                        accent: true,
                        icon: (
                          <svg
                            viewBox="0 0 24 24"
                            className="h-7 w-7 text-slate-600"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.75"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden
                          >
                            <path d="M9 18h6" />
                            <path d="M10 22h4" />
                            <path
                              d="M12 3a4 4 0 0 0-4 4v2a4 4 0 0 0 8 0V7a4 4 0 0 0-4-4Z"
                              className="text-amber-500"
                            />
                            <path
                              d="M15 13l4 7"
                              className="text-cyan-600"
                            />
                            <path d="M17 17l2 3" className="text-cyan-600" />
                          </svg>
                        ),
                      },
                      {
                        id: "personal",
                        label: "Personal Development",
                        accent: false,
                        icon: (
                          <svg
                            viewBox="0 0 24 24"
                            className="h-7 w-7 text-slate-600"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.75"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden
                          >
                            <path d="M4 18c2-4 6-5 8-7 2 2 6 3 8 7" />
                            <path
                              d="M12 11V7"
                              className="text-emerald-600"
                            />
                            <path
                              d="M12 7c-1-2-2-3-3-3 1 1 2 2 3 5 1-3 2-4 3-5-1 0-2 1-3 3Z"
                              className="text-emerald-600"
                            />
                          </svg>
                        ),
                      },
                    ].map((c, i) => (
                      <div
                        key={c.id}
                        className={cx(
                          "md:col-span-2",
                          i === 0 && "md:col-start-2",
                        )}
                      >
                        <EcosystemPillarCard {...c} />
                      </div>
                    ))}
                  </div>
                </div>

                <div className="relative mt-10 text-center sm:mt-12">
                  <a
                    href="#serendipity"
                    onClick={(event) => {
                      event.preventDefault();
                      scrollToSerendipitySection();
                    }}
                    className="inline-flex items-center justify-center text-sm font-semibold text-cyan-600 underline-offset-4 transition-colors hover:text-cyan-700 hover:underline"
                  >
                    See how everything connects
                  </a>
                </div>
              </div>
            </section>

            {/* Motivation / Identity */}
            <section className="bsi-reveal relative w-full overflow-hidden pt-12 pb-20 sm:pt-16 sm:pb-28">
              <div className="pointer-events-none absolute inset-0 -z-10">
                <div className="absolute left-1/2 top-10 h-[420px] w-[860px] -translate-x-1/2 rounded-full bg-cyan-200/18 blur-3xl" />
                <div className="absolute left-1/2 top-56 h-[420px] w-[860px] -translate-x-1/2 rounded-full bg-sky-200/12 blur-3xl" />
              </div>
              <div className="pointer-events-none absolute inset-0">
                {[
                  { s: 3, l: "14%", t: "24%", o: 0.12, d: 28, dl: -6 },
                  { s: 2, l: "78%", t: "30%", o: 0.1, d: 32, dl: -14 },
                  { s: 3, l: "46%", t: "68%", o: 0.1, d: 34, dl: -18 },
                  { s: 2, l: "22%", t: "72%", o: 0.1, d: 36, dl: -22 },
                ].map((p, i) => (
                  <span
                    key={i}
                    className="bsi-cta-dot"
                    style={{
                      width: `${p.s}px`,
                      height: `${p.s}px`,
                      left: p.l,
                      top: p.t,
                      opacity: p.o,
                      animationDuration: `${p.d}s`,
                      animationDelay: `${p.dl}s`,
                    }}
                  />
                ))}
              </div>

              <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
                <div className="relative mx-auto flex h-[140px] w-[140px] items-center justify-center sm:h-[168px] sm:w-[168px]">
                  <div className="pointer-events-none absolute inset-0 rounded-full bg-cyan-300/25 blur-3xl" />
                  <div className="pointer-events-none absolute -right-3 -top-2 flex h-9 w-9 items-center justify-center rounded-full bg-cyan-500 text-white shadow-[0_10px_24px_rgba(2,132,199,0.25)]">
                    <svg
                      viewBox="0 0 24 24"
                      className="h-4 w-4"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M4 18V6l8 5 8-5v12" />
                    </svg>
                  </div>
                  <div className="pointer-events-none absolute -bottom-2 -left-2 flex h-9 w-9 items-center justify-center rounded-full bg-cyan-500 text-white shadow-[0_10px_24px_rgba(2,132,199,0.25)]">
                    <svg
                      viewBox="0 0 24 24"
                      className="h-4 w-4"
                      fill="currentColor"
                    >
                      <path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8L12 2z" />
                    </svg>
                  </div>
                  <div className="relative flex h-full w-full items-center justify-center rounded-full border-2 border-cyan-400/80 bg-white shadow-[0_18px_55px_rgba(2,132,199,0.18)]">
                    <svg
                      viewBox="0 0 24 24"
                      className="h-14 w-14 text-cyan-500 sm:h-16 sm:w-16"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                    >
                      <path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Z" />
                      <path d="M6 20.5c1.2-3.2 3.8-5 6-5s4.8 1.8 6 5" />
                    </svg>
                  </div>
                </div>

                <h3 className="mt-10 text-3xl font-extrabold leading-tight tracking-tight text-slate-900 sm:text-4xl sm:leading-[1.15]">
                  You are not just{" "}
                  <span className="text-cyan-500">tracking goals.</span>
                  <br />
                  You are{" "}
                  <span className="text-cyan-500">discovering patterns.</span>
                </h3>

                <p className="mx-auto mt-6 max-w-2xl text-sm font-medium leading-7 text-slate-500 sm:text-base">
                  Every interaction, every completed task, every moment of
                  reflection — they all weave together into a story of growth
                  that&apos;s uniquely yours.
                </p>

                <div className="mx-auto mt-12 grid max-w-lg grid-cols-3 gap-6 sm:max-w-xl sm:gap-10">
                  {[
                    { label: "Journey" },
                    { label: "Patterns" },
                    { label: "Growth" },
                  ].map((x) => (
                    <div key={x.label} className="text-center">
                      <div className="text-sm font-extrabold text-cyan-500">
                        Your
                      </div>
                      <div className="mt-1 text-xs font-semibold text-slate-500 sm:text-sm">
                        {x.label}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* Mobile */}
            <section className="bsi-reveal relative w-full overflow-hidden py-20 sm:py-28">
              <div className="pointer-events-none absolute inset-0 -z-10">
                <div className="absolute left-1/2 top-24 h-[560px] w-[980px] -translate-x-1/2 rounded-full bg-cyan-200/18 blur-3xl" />
                <div className="absolute left-1/2 top-64 h-[560px] w-[980px] -translate-x-1/2 rounded-full bg-sky-200/14 blur-3xl" />
              </div>
              {/* scattered bubbles */}
              <div className="pointer-events-none absolute inset-0">
                {[
                  { s: 160, l: "6%", t: "10%", o: 0.1, b: 44 },
                  { s: 90, l: "18%", t: "58%", o: 0.1, b: 30 },
                  { s: 220, l: "76%", t: "14%", o: 0.09, b: 54 },
                  { s: 120, l: "86%", t: "64%", o: 0.08, b: 40 },
                  { s: 70, l: "52%", t: "8%", o: 0.09, b: 26 },
                ].map((x, i) => (
                  <span
                    key={i}
                    className="absolute rounded-full"
                    style={{
                      width: `${x.s}px`,
                      height: `${x.s}px`,
                      left: x.l,
                      top: x.t,
                      opacity: x.o,
                      filter: `blur(${x.b}px)`,
                      background:
                        "radial-gradient(circle at 30% 30%, rgba(0,198,255,0.40), rgba(0,114,255,0.10))",
                    }}
                  />
                ))}
              </div>

              <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
                <div className="relative grid grid-cols-1 gap-14 lg:grid-cols-2 lg:items-center">
                  {/* LEFT */}
                  <div className="text-left">
                    <div className="inline-flex items-center rounded-full bg-cyan-50 px-4 py-2 text-xs font-semibold text-cyan-700 ring-1 ring-cyan-100">
                      Download Now
                    </div>

                    <h3 className="mt-6 text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl sm:leading-[1.1]">
                      Take Your <span className="text-cyan-500">Growth</span>{" "}
                      With You
                    </h3>
                    <p className="mt-4 max-w-xl text-sm font-medium leading-6 text-slate-500 sm:text-base">
                      Available on iOS and Android. Your goals, your progress,
                      your discoveries — all in your pocket. Start your journey
                      today.
                    </p>

                    <div className="mt-8 flex flex-wrap gap-3">
                      <a
                        href="https://apps.apple.com/us/app/bsi-blue-sky-index/id6468769002"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-3 rounded-2xl bg-slate-900 px-5 py-3 text-white shadow-[0_14px_28px_rgba(15,23,42,0.18)] transition-transform duration-300 hover:-translate-y-0.5 hover:bg-slate-950"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          className="h-5 w-5"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M16.7 13.9c0-2.2 1.8-3.3 1.9-3.4-1-1.5-2.6-1.7-3.1-1.7-1.3-.1-2.6.8-3.2.8-.7 0-1.7-.8-2.8-.8-1.4 0-2.8.8-3.5 2.1-1.5 2.6-.4 6.4 1.1 8.5.7 1 1.5 2.1 2.6 2.1 1 0 1.4-.6 2.7-.6 1.2 0 1.6.6 2.7.6 1.1 0 1.8-1 2.5-2 .8-1.2 1.1-2.3 1.1-2.4 0-.1-2-.8-2-3.2z" />
                          <path d="M14.6 4.9c.6-.8 1-1.9.9-3-1 .1-2.1.7-2.8 1.5-.6.7-1.1 1.9-.9 3 1.1.1 2.2-.6 2.8-1.5z" />
                        </svg>
                        <div className="leading-tight">
                          <div className="text-[11px] font-semibold text-white/80">
                            Download on the
                          </div>
                          <div className="text-sm font-extrabold">
                            App Store
                          </div>
                        </div>
                      </a>

                      <a
                        href="https://play.google.com/store/apps/details?id=com.app.serendipity&pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-3 rounded-2xl bg-slate-900 px-5 py-3 text-white shadow-[0_14px_28px_rgba(15,23,42,0.18)] transition-transform duration-300 hover:-translate-y-0.5 hover:bg-slate-950"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          className="h-5 w-5"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M3.6 2.9c-.4.4-.6 1-.6 1.7v14.8c0 .7.2 1.3.6 1.7l.1.1L13 12 3.7 2.8l-.1.1z" />
                          <path d="M16.6 15.1 13 12l3.6-3.1 4.3 2.4c.8.4.8 1.4 0 1.8l-4.3 2z" />
                          <path d="M13 12 3.7 21.2c.4.4 1 .5 1.7.1l11.2-6.3L13 12z" />
                          <path d="M13 12l3.6-3.1L5.4 2.6c-.7-.4-1.3-.3-1.7.1L13 12z" />
                        </svg>
                        <div className="leading-tight">
                          <div className="text-[11px] font-semibold text-white/80">
                            Get it on
                          </div>
                          <div className="text-sm font-extrabold">
                            Google Play
                          </div>
                        </div>
                      </a>
                    </div>

                    <div className="mt-6 flex flex-wrap items-center gap-5 text-xs font-semibold text-slate-500">
                      <div className="flex items-center gap-2">
                        <span className="h-2 w-2 rounded-full bg-emerald-400" />
                        Free to Download
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="h-2 w-2 rounded-full bg-sky-400" />
                        No Credit Card
                      </div>
                    </div>
                  </div>

                  {/* RIGHT */}
                  <div className="relative flex justify-center lg:justify-end">
                    {/* strong soft glow behind phone */}
                    {/* <div className="pointer-events-none absolute right-1/2 top-1/2 h-[640px] w-[640px] -translate-y-1/2 translate-x-1/2 rounded-full bg-cyan-300/40 blur-[88px] lg:right-20 lg:translate-x-0" />
                <div className="pointer-events-none absolute right-1/2 top-1/2 h-[460px] w-[460px] -translate-y-1/2 translate-x-1/2 rounded-full bg-[#0072FF]/18 blur-[86px] lg:right-20 lg:translate-x-0" />
                <div className="pointer-events-none absolute right-1/2 top-1/2 h-[320px] w-[320px] -translate-y-1/2 translate-x-1/2 rounded-full bg-sky-200/30 blur-[78px] lg:right-20 lg:translate-x-0" /> */}

                    <div className="relative -translate-y-2 transition-transform duration-300 hover:-translate-y-3">
                      {/* soft shadow under phone (no frame) */}
                      <div className="pointer-events-none absolute inset-x-12 -bottom-8 h-24 rounded-full bg-slate-900/12 blur-2xl" />
                      {/* <img
                    src={img2}
                    alt="Mobile preview"
                    loading="lazy"
                    className="bsi-phone-float relative h-[620px] w-auto max-w-full select-none object-contain drop-shadow-[0_26px_55px_rgba(15,23,42,0.22)]"
                    style={{ imageRendering: "auto" }}
                  /> */}

                      {/* phone-attached floating icon */}
                      <div className="absolute bottom-36 right-16 sm:bottom-5 sm:right-[-18px]">
                        <div className="group relative">
                          <div className="pointer-events-none absolute -inset-3 rounded-full bg-cyan-300/35 blur-xl transition-opacity duration-300 group-hover:opacity-100" />
                          {/* <div
                        className="relative flex h-11 w-11 items-center justify-center rounded-full text-white shadow-[0_18px_45px_rgba(0,114,255,0.30)] ring-1 ring-white/35 transition-transform duration-300 group-hover:scale-[1.04]"
                        style={primaryGradient}
                      >
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          className="h-[18px] w-[18px]"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z" />
                          <path d="M11 19h2" />
                        </svg>
                      </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Contact */}
            <section
              id="contact"
              ref={feedbackRef}
              className="bsi-reveal scroll-mt-20 pt-14 sm:scroll-mt-24 sm:pt-20"
            >
              <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
                <div className="relative overflow-hidden rounded-3xl py-12 sm:py-16">
                  {/* subtle center glow (like reference) */}
                  <div className="pointer-events-none absolute inset-0">
                    <div className="absolute left-1/2 top-10 h-72 w-72 -translate-x-1/2 rounded-full bg-cyan-200/35 blur-3xl" />
                    <div className="absolute left-10 top-24 h-24 w-24 rounded-full bg-sky-200/35 blur-2xl" />
                    <div className="absolute right-10 bottom-10 h-28 w-28 rounded-full bg-cyan-200/30 blur-2xl" />
                  </div>

                  <div className="relative text-center">
                    <div className="mx-auto inline-flex items-center rounded-full bg-cyan-50 px-4 py-2 text-xs font-semibold text-cyan-700 ring-1 ring-cyan-100">
                      Get in Touch
                    </div>
                    <h3 className="mt-5 text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
                      Let&apos;s <span className="text-cyan-500">Connect</span>
                    </h3>
                    <p className="mx-auto mt-3 max-w-2xl text-sm font-medium text-slate-500 sm:text-base">
                      Have questions about your journey? We&apos;re here to help
                      you discover your path.
                    </p>
                  </div>

                  <div className="relative mx-auto mt-10 grid max-w-4xl grid-cols-1 gap-6 sm:grid-cols-3 sm:gap-8">
                    {[
                      {
                        title: "Call Us",
                        value: "+31 6 16652615",
                        icon: (
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            className="h-6 w-6"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.86.3 1.7.54 2.5a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.58-1.06a2 2 0 0 1 2.11-.45c.8.24 1.64.42 2.5.54A2 2 0 0 1 22 16.92z" />
                          </svg>
                        ),
                      },
                      {
                        title: "Email Us",
                        value: "info@blueskyindex.com",
                        icon: (
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            className="h-6 w-6"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M4 4h16v16H4z" opacity=".1" />
                            <path d="M4 4h16v16H4z" />
                            <path d="m4 7 8 6 8-6" />
                          </svg>
                        ),
                      },
                      {
                        title: "Live Chat",
                        value: "Coming Soon",
                        icon: (
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            className="h-6 w-6"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8Z" />
                          </svg>
                        ),
                      },
                    ].map((c) => (
                      <div
                        key={c.title}
                        className={cx(
                          softCard,
                          softCardInteractive,
                          "flex flex-col items-center justify-center px-6 py-8 text-center",
                        )}
                      >
                        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-b from-cyan-400 to-sky-500 text-white shadow-[0_18px_40px_rgba(2,132,199,0.25)]">
                          {c.icon}
                        </div>
                        <div className="mt-5 text-sm font-extrabold text-slate-900">
                          {c.title}
                        </div>
                        <div className="mt-2 text-xs font-semibold text-cyan-600">
                          {c.value}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>

            {/* Map Section - FULL WIDTH ONLY (existing map logic preserved) */}
            <section className="bsi-reveal pt-14 sm:pt-20">
              <div
                className="relative w-full pt-14 sm:pt-16"
                style={{
                  backgroundImage: [
                    "radial-gradient(640px 360px at 50% 18%, rgba(0,198,255,0.16), transparent 72%)",
                    "radial-gradient(920px 520px at 50% 34%, rgba(0,114,255,0.08), transparent 74%)",
                  ].join(","),
                }}
              >
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
                  <div className="text-center">
                    <h3 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
                      Explore the Map
                    </h3>
                    <p className="mx-auto mt-3 max-w-2xl text-sm font-medium text-slate-500 sm:text-base">
                      Full-width map with your existing markers and city logic.
                    </p>
                  </div>
                </div>

                <div className="mt-10 w-full">
                  <div className="w-full overflow-hidden bg-white/0">
                    <div className="h-[460px] w-full sm:h-[560px]">
                      <>
                        {mapSectionError ? (
                          <div className="flex h-full flex-col items-center justify-center gap-4 bg-white/60 backdrop-blur-sm">
                            <p className="text-red-500">{mapSectionError}</p>
                            <button
                              type="button"
                              onClick={handleRetry}
                              className="rounded-full bg-cyan-500 px-4 py-2 text-sm font-semibold text-white hover:bg-cyan-600"
                            >
                              Retry
                            </button>
                          </div>
                        ) : !isLoaded ? (
                          <div className="flex h-full flex-col items-center justify-center gap-3 bg-white/60 backdrop-blur-sm">
                            <p className="text-sm font-semibold text-slate-600">
                              Loading Google Maps
                              {retryCount > 0
                                ? ` (Attempt ${retryCount + 1}/${maxRetries + 1})`
                                : "..."}
                            </p>
                          </div>
                        ) : (
                          <GoogleMap
                            mapContainerStyle={{
                              width: "100%",
                              height: "100%",
                            }}
                            onLoad={(map) => {
                              requestAnimationFrame(() => {
                                if (window.google?.maps?.event) {
                                  window.google.maps.event.trigger(
                                    map,
                                    "resize",
                                  );
                                }
                              });
                            }}
                            center={
                              markers.length > 0
                                ? {
                                    lat: markers[0].coordinates[0],
                                    lng: markers[0].coordinates[1],
                                  }
                                : cityCenters[city]
                            }
                            zoom={14}
                            options={{
                              streetViewControl: false,
                              fullscreenControl: true,
                              mapTypeControl: false,
                              mapTypeId: "roadmap",
                              styles: mapStyles,
                              restriction: {
                                latLngBounds: {
                                  north: 53.7,
                                  south: 50.5,
                                  west: 3.2,
                                  east: 7.2,
                                },
                                strictBounds: true,
                              },
                            }}
                          >
                            {markers.map((m) => {
                              const lat = m.coordinates[0];
                              const lng = m.coordinates[1];
                              let iconPath = null;
                              let isSymbol = true;

                              switch (m.shape) {
                                case "circle":
                                  iconPath =
                                    window.google.maps.SymbolPath.CIRCLE;
                                  break;
                                case "marker":
                                default:
                                  isSymbol = false;
                                  break;
                              }

                              const markerProps = {
                                key: m._id,
                                position: { lat, lng },
                                label: {
                                  text: String(m.number),
                                  color: "#fff",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                },
                              };

                              if (isSymbol) {
                                markerProps.icon = {
                                  path: iconPath,
                                  fillColor: m.color,
                                  fillOpacity: 1,
                                  strokeWeight: 1,
                                  scale: 10,
                                };
                              } else {
                                markerProps.icon = {
                                  path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z",
                                  fillColor: m.color,
                                  fillOpacity: 1,
                                  strokeColor: "#000",
                                  strokeWeight: 1,
                                  scale: 1.5,
                                  anchor: new window.google.maps.Point(12, 24),
                                  labelOrigin: new window.google.maps.Point(
                                    12,
                                    10,
                                  ),
                                };
                              }

                              return <Marker {...markerProps} />;
                            })}
                          </GoogleMap>
                        )}
                      </>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* CTA */}
            <section
              className="bsi-reveal relative w-full overflow-hidden py-20 sm:py-28 bg-white"
            >
              <img
                src={bubble4}
                alt=""
                className="bsi-bubble-img bsi-float bsi-bubble-hide-mobile"
                style={{
                  bottom: "-3%",
                  width: "100%",
                  opacity: 10,
                  transform: "translateX(-50%)",
                  zIndex: 1000,
                  animationDelay: "-2.2s",
                }}
              />

          

              <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
                <div className="relative mx-auto flex max-w-3xl flex-col items-center text-center">
                  {/* icon */}
                  <div
                    className="flex h-14 w-14 items-center justify-center rounded-full text-white shadow-[0_18px_50px_rgba(0,114,255,0.22)]"
                    style={primaryGradient}
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      className="h-6 w-6"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M12 2l1.2 4.6L18 8l-4.8 1.4L12 14l-1.2-4.6L6 8l4.8-1.4L12 2Z" />
                      <path d="M19 13l.7 2.7L22 16.5l-2.3.8L19 20l-.7-2.7L16 16.5l2.3-.8L19 13Z" />
                    </svg>
                  </div>

                  {/* heading */}
                  <h3 className="mt-7 text-3xl font-medium tracking-tight text-slate-900 sm:text-5xl sm:leading-[1.1]">
                    Sometimes the next step
                  </h3>
                  <div
                    className="mt-2 bg-clip-text text-4xl font-extrabold tracking-tight text-transparent sm:text-6xl sm:leading-[1.05]"
                    style={primaryGradient}
                  >
                    is not planned.
                  </div>

                  {/* description */}
                  <p className="mt-5 max-w-xl text-sm font-medium leading-6 text-slate-500 sm:text-base">
                    Let serendipity guide you to discoveries you never knew you
                    were looking for.
                  </p>

                  {/* button */}
                  <button
                    onClick={() => navigate("/signup")}
                    className="mt-8 inline-flex items-center justify-center whitespace-nowrap rounded-full px-8 py-3.5 text-sm font-semibold text-white shadow-[0_18px_55px_rgba(0,114,255,0.22)] transition-transform duration-300 hover:scale-[1.02] hover:brightness-95"
                    style={primaryGradient}
                  >
                    Enter the Experience <span className="ml-2">→</span>
                  </button>

                  {/* subtext */}
                  <p className="mt-6 text-xs font-semibold text-slate-400/90">
                    Join thousands discovering their potential through
                    serendipity
                  </p>
                </div>
              </div>
            </section>

            <Footer
              onHomeClick={scrollToHome}
              onContactClick={scrollToFeedback}
              onSerendipityClick={scrollToSerendipitySection}
            />
          </div>
        </main>
      </div>
    </>
  );
}

export default Landing;
